(function () {
  'use strict';

  var SESSION_KEY = 'peakLovePreloaderSeen';
  var REVEAL_DURATION = 1.8;
  var HOLD_DURATION = 0.5;
  var CLIP_FULL = 'inset(0% 0% 0% 0%)';
  var CLIP_HIDDEN = 'inset(0% 0% 100% 0%)';

  var preloader = document.getElementById('preloader');
  if (!preloader) return;

  var logoWrap = document.getElementById('logoWrap');
  var logoSlot = null;

  var prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  function hasSeenPreloader() {
    try {
      return sessionStorage.getItem(SESSION_KEY) === '1';
    } catch (error) {
      return false;
    }
  }

  function markPreloaderSeen() {
    try {
      sessionStorage.setItem(SESSION_KEY, '1');
    } catch (error) {
      // Ignore storage failures (private mode, etc.).
    }
  }

  function setPanelClip(panel, value) {
    if (!panel) return;
    gsap.set(panel, { clipPath: value, webkitClipPath: value });
  }

  function restoreLogo() {
    if (!logoWrap) return;

    gsap.killTweensOf(logoWrap);
    gsap.set(logoWrap, {
      clearProps: 'transform,zIndex,position,top,left,width,height,margin',
    });
    logoWrap.classList.remove('is-preloader-pinned');

    if (logoSlot && logoSlot.parentNode) {
      logoSlot.parentNode.insertBefore(logoWrap, logoSlot);
      logoSlot.parentNode.removeChild(logoSlot);
    }

    logoSlot = null;
  }

  function enableSite() {
    document.documentElement.classList.remove('scrollBlock');
    document.body.classList.remove('is-preloading');
    preloader.remove();

    if (window.setCanStartAnimations) {
      window.setCanStartAnimations(true);
    }

    if (window.lenis && !document.body.classList.contains('page-home')) {
      window.lenis.start();
    }
  }

  function skipPreloader() {
    function done() {
      if (typeof gsap !== 'undefined' && logoWrap) {
        restoreLogo();
      }
      enableSite();
    }

    if ('peakLoveLogo' in window || !logoWrap) {
      done();
      return;
    }

    var frames = 0;
    requestAnimationFrame(function waitForLogo() {
      frames += 1;
      if ('peakLoveLogo' in window || frames > 120) {
        done();
        return;
      }

      requestAnimationFrame(waitForLogo);
    });
  }

  if (hasSeenPreloader()) {
    skipPreloader();
    return;
  }

  function getViewportOffsetToCenter() {
    var rect = logoWrap.getBoundingClientRect();
    var centerX = rect.left + rect.width / 2;
    var centerY = rect.top + rect.height / 2;

    return {
      x: window.innerWidth / 2 - centerX,
      y: window.innerHeight / 2 - centerY,
    };
  }

  function getDispersedFitScale() {
    var svg = logoWrap.querySelector('svg');
    if (!svg || !svg.getBBox) return 1;

    var contentBox;
    try {
      contentBox = svg.getBBox();
    } catch (e) {
      return 1;
    }

    var viewBox = svg.viewBox.baseVal;
    if (!viewBox || !viewBox.width || !contentBox.width) return 1;

    var pxPerUnit = svg.getBoundingClientRect().width / viewBox.width;
    var dispersedWidth = contentBox.width * pxPerUnit;
    var available = window.innerWidth * 0.85;

    return Math.min(1, available / dispersedWidth);
  }

  function centerLogo() {
    var rect = logoWrap.getBoundingClientRect();
    var offset = getViewportOffsetToCenter();

    logoSlot = document.createElement('div');
    logoSlot.setAttribute('aria-hidden', 'true');
    logoSlot.style.width = rect.width + 'px';
    logoSlot.style.height = rect.height + 'px';
    logoSlot.style.flex = 'none';
    logoWrap.parentNode.insertBefore(logoSlot, logoWrap);

    document.body.appendChild(logoWrap);
    logoWrap.classList.add('is-preloader-pinned');

    gsap.set(logoWrap, {
      position: 'fixed',
      left: rect.left,
      top: rect.top,
      width: rect.width,
      margin: 0,
      x: offset.x,
      y: offset.y,
      scale: getDispersedFitScale(),
      transformOrigin: '50% 50%',
      zIndex: 10001,
      force3D: true,
    });
  }

  function finish() {
    restoreLogo();
    markPreloaderSeen();
    enableSite();
  }

  function revealSite() {
    var panel = preloader.querySelector('.preloader__panel');
    var tl = gsap.timeline({ onComplete: finish });

    tl.to(panel, {
      clipPath: CLIP_HIDDEN,
      webkitClipPath: CLIP_HIDDEN,
      duration: REVEAL_DURATION,
      ease: 'power2.inOut',
    });

    if (logoWrap) {
      tl.to(
        logoWrap,
        {
          x: 0,
          y: 0,
          scale: 1,
          duration: REVEAL_DURATION,
          ease: 'power2.inOut',
          force3D: true,
        },
        '<'
      );
    }
  }

  function run() {
    if (prefersReducedMotion || typeof gsap === 'undefined') {
      if (window.peakLoveLogo && window.peakLoveLogo.playOut) {
        window.peakLoveLogo.playOut();
      }
      if (typeof gsap !== 'undefined' && logoWrap) {
        restoreLogo();
      }
      markPreloaderSeen();
      enableSite();
      return;
    }

    document.documentElement.classList.add('scrollBlock');
    document.body.classList.add('is-preloading');

    if (window.lenis) {
      window.lenis.stop();
    }

    var logo = window.peakLoveLogo;
    var panel = preloader.querySelector('.preloader__panel');
    setPanelClip(panel, CLIP_FULL);

    requestAnimationFrame(function () {
      if (logoWrap) {
        centerLogo();
      }

      gsap.delayedCall(HOLD_DURATION, function () {
        if (logo && logo.playOut) {
          logo.playOut(revealSite);
        } else {
          revealSite();
        }
      });
    });
  }

  function waitForLogo() {
    if ('peakLoveLogo' in window || !logoWrap) {
      run();
      return;
    }

    var frames = 0;
    requestAnimationFrame(function poll() {
      frames += 1;
      if ('peakLoveLogo' in window || frames > 120) {
        run();
        return;
      }
      requestAnimationFrame(poll);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForLogo);
  } else {
    waitForLogo();
  }
})();
